import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';

import { CARD_SELECTOR, cardSlug } from './utils/landingCards';

const COUNT_CLASS = 'cm-cat-count';

/**
 * (e) Contadores de categoria en la home, con el numero REAL.
 *
 * Fuente: `discussionCount` de los modelos `tags` que `flarum/tags` ya serializa en el
 * payload del foro (`ForumSerializer` + los includes de `ShowForumController`). No se pide
 * nada extra a la API y no se inventa ningun numero.
 *
 * Consecuencia buscada: si una etiqueta NO esta en el payload de esta sesion — el caso de
 * `n8n-chile`, restringida e invisible para el anonimo — la tarjeta se queda sin contador
 * en vez de mostrar un cero falso o un numero de relleno.
 *
 * Por que se pinta por DOM y no con Mithril: la home (`#cm-home`) la inyecta `custom_header`
 * y vive como hermana de `#app`, fuera del arbol que Mithril controla (ver forum.blade.php).
 * T06 migra el CSS a la extension pero deja ese HTML donde esta; cuando la home pase a ser
 * un componente propio, esta funcion desaparece.
 */
function paintCounts() {
  const cards = document.querySelectorAll<HTMLAnchorElement>(CARD_SELECTOR);

  if (!cards.length) return;

  const tags = app.store.all<any>('tags');

  cards.forEach((card) => {
    const heading = card.querySelector('h5');

    if (!heading) return;

    // Se mira el destino ORIGINAL: `retargetLandingLinks` puede haber reescrito el href de la
    // tarjeta n8n a la pagina publica, y entonces el `href` vivo ya no lleva el slug.
    const slug = cardSlug(card);
    const tag: any = slug ? tags.find((t: any) => t.slug() === slug) : null;
    const existing = heading.querySelector('.' + COUNT_CLASS);
    const count = tag && typeof tag.discussionCount === 'function' ? tag.discussionCount() : null;

    if (typeof count !== 'number') {
      // Sin dato real no se muestra nada (y se limpia lo que hubiera de un render previo,
      // p. ej. tras cerrar sesion y perder la visibilidad de una etiqueta restringida).
      if (existing) existing.remove();
      return;
    }

    const node = existing || document.createElement('span');

    node.className = COUNT_CLASS;
    node.textContent = String(count);
    node.setAttribute('data-cm-count-slug', slug || '');

    if (!existing) heading.appendChild(node);
  });
}

export default function addCategoryCounts() {
  // Los initializers corren ANTES de `store.pushPayload()` dentro de `Application.boot()`,
  // asi que aqui todavia no hay etiquetas que leer. `IndexPage.oncreate` es el primer punto
  // con la store poblada, y vuelve a dispararse al navegar de vuelta a la home por el SPA.
  extend(IndexPage.prototype, 'oncreate', paintCounts);
}
